import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { useAuth } from '../authContext';
import { theme } from '../lib/theme';

export default function MarketplacePassengerDash() {
  const { profile, signOutUser } = useAuth();
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState('');

  const load = useCallback(async () => {
    if (!profile?.id) return;
    setLoading(true);
    setLoadError('');
    const { data, error } = await supabase
      .from('bookings')
      .select('*')
      .eq('passenger_id', profile.id)
      .order('created_at', { ascending: false });
    if (error) {
      setLoadError(error.message);
      setBookings([]);
    } else {
      setBookings(data || []);
    }
    setLoading(false);
  }, [profile?.id]);

  useEffect(() => {
    load();
  }, [load]);

  return (
    <div style={{ minHeight: '100vh', background: theme.bg, color: theme.text, fontFamily: theme.font }}>
      <header style={{ padding: '20px 24px', borderBottom: '1px solid rgba(255,255,255,0.07)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Link to="/" style={{ color: theme.text, textDecoration: 'none', fontWeight: 700 }}>Transport Team</Link>
        <button type="button" onClick={async () => { await signOutUser(); navigate('/'); }} style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.12)', color: theme.muted, padding: '8px 14px', borderRadius: 8, cursor: 'pointer' }}>
          Sign out
        </button>
      </header>
      <main style={{ maxWidth: 720, margin: '0 auto', padding: '32px 24px' }}>
        <h1 style={{ fontSize: 22, fontWeight: 800, marginBottom: 8 }}>My bookings</h1>
        <p style={{ color: theme.muted, marginBottom: 24 }}>Hello, {profile?.full_name || 'there'}</p>
        <Link to="/book" style={{ display: 'inline-block', marginBottom: 28, padding: '12px 24px', background: theme.accent, color: '#fff', borderRadius: 10, textDecoration: 'none', fontWeight: 600 }}>
          Book a driver
        </Link>
        {loadError ? <p style={{ color: '#f87171', marginBottom: 16 }}>{loadError}</p> : null}
        {loading ? (
          <p style={{ color: theme.muted }}>Loading…</p>
        ) : bookings.length === 0 ? (
          <p style={{ color: theme.muted }}>No bookings yet.</p>
        ) : (
          bookings.map((b) => (
            <div key={b.id} style={{ background: theme.bg1, border: '1px solid rgba(255,255,255,0.07)', borderRadius: 12, padding: 16, marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8 }}>
                <strong>{b.package?.replace('_', ' ') || 'Trip'}</strong>
                <span style={{ fontSize: 12, color: theme.accentLight, textTransform: 'uppercase' }}>{b.status}</span>
              </div>
              <p style={{ margin: 0, fontSize: 14, color: theme.muted }}>
                {b.start_date} · {b.area || b.pickup} · ₦{Number(b.price || 0).toLocaleString()}
              </p>
            </div>
          ))
        )}
      </main>
    </div>
  );
}
